/**
 * Message catalogs. `tr` is the source of truth for keys; every other locale must provide the
 * same keys (enforced by the type and by a test). Plural forms use Intl.PluralRules categories.
 */

export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };
export type Entry = string | PluralForms;

export const tr = {
  'app.loading': 'Yükleniyor…',
  'nav.messages': 'Mesajlar',
  'nav.calls': 'Aramalar',
  'nav.spaces': 'Alanlar',
  'nav.discover': 'Keşfet',
  'nav.ai': 'Yapay Zekâ',
  'nav.settings': 'Ayarlar',
  'auth.login.title': 'Giriş yap',
  'auth.register.title': 'Hesap oluştur',
  'auth.identifier': 'E-posta veya kullanıcı adı',
  'auth.email': 'E-posta',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Parola',
  'auth.passwordHint': 'En az 10 karakter',
  'auth.displayName': 'Görünen ad',
  'auth.birthDate': 'Doğum tarihi',
  'auth.birthDateHint': 'Yaşına uygun güvenlik ayarlarını belirlemek için kullanılır; profilinde gösterilmez.',
  'auth.country': 'Ülke',
  'auth.acceptTerms': 'Kullanım koşullarını ve gizlilik bildirimini okudum, kabul ediyorum.',
  'auth.submitLogin': 'Giriş yap',
  'auth.submitRegister': 'Hesap oluştur',
  'auth.noAccount': 'Hesabın yok mu?',
  'auth.haveAccount': 'Zaten hesabın var mı?',
  'auth.logout': 'Çıkış yap',
  'auth.or': 'veya',
  'auth.forgotLink': 'Parolamı unuttum',
  'auth.forgot.title': 'Parolanı sıfırla',
  'auth.forgot.body': 'Hesabının e-posta adresini yaz. Bir hesap varsa sıfırlama bağlantısı göndereceğiz.',
  'auth.forgot.submit': 'Bağlantı gönder',
  'auth.forgot.sent': 'Bu adrese kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi. Bağlantı 30 dakika geçerli.',
  'auth.reset.title': 'Yeni parola belirle',
  'auth.reset.newPassword': 'Yeni parola',
  'auth.reset.submit': 'Parolayı değiştir',
  'auth.reset.done': 'Parolan değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Yeni parolanla giriş yapabilirsin.',
  'auth.verify.title': 'E-posta doğrulama',
  'auth.verify.working': 'Doğrulanıyor…',
  'auth.verify.success': 'E-posta adresin doğrulandı.',
  'auth.verify.continue': 'Uygulamaya dön',
  'auth.passkey.login': 'Passkey ile giriş yap',
  'auth.passkey.unsupported': 'Bu tarayıcı passkey desteklemiyor.',
  'auth.passkey.cancelled': 'Passkey işlemi iptal edildi.',
  'banner.emailUnverified': 'E-posta adresini doğrula: {email}',
  'banner.resend': 'Bağlantıyı tekrar gönder',
  'banner.resent': 'Doğrulama bağlantısı gönderildi.',
  'passkeys.title': 'Passkey’ler',
  'passkeys.body': 'Parola yerine cihazının kilidiyle (parmak izi, yüz, PIN) giriş yap.',
  'passkeys.add': 'Passkey ekle',
  'passkeys.empty': 'Henüz passkey eklemedin.',
  'passkeys.created': 'Eklendi: {date}',
  'passkeys.lastUsed': 'Son kullanım: {date}',
  'passkeys.remove': 'Kaldır',
  'passkeys.added': 'Passkey eklendi.',
  'passkeys.synced': 'Senkronize',
  'mail.verify.subject': '{brand}: e-posta adresini doğrula',
  'mail.verify.body': 'Merhaba {name},\n\n{brand} hesabının e-posta adresini doğrulamak için aşağıdaki bağlantıyı kullan. Bağlantı 24 saat geçerli.',
  'mail.verify.cta': 'E-postamı doğrula',
  'mail.reset.subject': '{brand}: parola sıfırlama',
  'mail.reset.body': 'Merhaba {name},\n\nParolanı sıfırlamak için aşağıdaki bağlantıyı kullan. Bağlantı 30 dakika geçerli ve tek kullanımlık. Bu isteği sen yapmadıysan bu e-postayı yok sayabilirsin; parolan değişmez.',
  'mail.reset.cta': 'Parolamı sıfırla',
  'mail.passwordChanged.subject': '{brand}: parolan değiştirildi',
  'mail.passwordChanged.body': 'Merhaba {name},\n\n{brand} hesabının parolası az önce değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Bunu sen yapmadıysan hemen destek ekibiyle iletişime geç.',
  'mail.passwordChanged.cta': 'Giriş yap',
  'mail.footer': 'Bu e-posta {brand} hesabınla ilgili bir işlem nedeniyle otomatik gönderildi.',
  'chat.title': 'Sohbetler',
  'chat.search': 'Sohbetlerde ara',
  'chat.new': 'Yeni sohbet',
  'chat.empty': 'Henüz sohbetin yok. Kişiler bölümünden @kullanıcıadı ile birini ekleyip sohbet başlat.',
  'chat.select': 'Bir sohbet seç',
  'chat.selectBody': 'Soldaki listeden bir sohbet seç ya da yeni bir sohbet başlat.',
  'chat.placeholder': 'Mesaj yaz',
  'chat.send': 'Gönder',
  'chat.typing': '{name} yazıyor…',
  'chat.loadOlder': 'Önceki mesajları yükle',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.you': 'Sen',
  'chat.noMessages': 'Henüz mesaj yok. İlk mesajı sen yaz.',
  'chat.status.queued': 'Gönderilmeyi bekliyor',
  'chat.status.sending': 'Gönderiliyor',
  'chat.status.sent': 'Gönderildi',
  'chat.status.delivered': 'İletildi',
  'chat.status.read': 'Okundu',
  'chat.status.failed': 'Gönderilemedi',
  'chat.retry': 'Tekrar dene',
  'chat.discard': 'Sil',
  'chat.cannotSend': 'Bu kişiye şu an mesaj gönderemezsin.',
  'chat.waitForReply': 'Bu kişi seni kişilerine eklediğinde ya da sana yazdığında cevap verebilirsin.',
  'chat.verifyToSend': 'Mesaj göndermek için önce e-posta adresini doğrula.',
  'chat.restrictedToSend': 'Mesajlaşma veli/vasi onayı tamamlandığında açılır.',
  'chat.encryptionNotice': 'Mesajlar sunucuya şifreli bağlantıyla (TLS) iletilir ve sunucuda saklanır. Uçtan uca şifreleme henüz yok.',
  'chat.unread': { one: '{count} okunmamış mesaj', other: '{count} okunmamış mesaj' },
  'chat.back': 'Sohbetlere dön',
  'contacts.title': 'Kişiler',
  'contacts.add': 'Ekle',
  'contacts.addLabel': 'Kullanıcı adıyla kişi ekle',
  'contacts.usernamePlaceholder': '@kullanıcıadı',
  'contacts.added': '{name} kişilerine eklendi.',
  'contacts.empty': 'Henüz kişin yok.',
  'contacts.message': 'Mesaj',
  'contacts.block': 'Engelle',
  'contacts.unblock': 'Engeli kaldır',
  'contacts.blocked': 'Engellendi',
  'contacts.hint': 'Birini eklemek onun sana yazabilmesini sağlar. Sen ona yazabilmek için onun da seni eklemesi ya da herkesten mesaj kabul etmesi gerekir.',
  'push.newMessage': 'Yeni mesaj',
  'push.newMessageHidden': 'Yeni bir mesajın var',
  'notifications.title': 'Bildirimler',
  'notifications.body': 'Uygulama kapalıyken yeni mesajlardan haberdar ol.',
  'notifications.enable': 'Bu cihazda bildirimleri aç',
  'notifications.disable': 'Bu cihazda kapat',
  'notifications.enabled': 'Bu cihazda bildirimler açık.',
  'notifications.denied': 'Tarayıcı bildirim iznini engelledi. İzni tarayıcının site ayarlarından açabilirsin.',
  'notifications.unsupported': 'Bu tarayıcı web bildirimlerini desteklemiyor.',
  'notifications.unavailable': 'Bildirimler şu an kullanılamıyor.',
  'notifications.preview': 'Bildirimde göster',
  'notifications.preview.full': 'Gönderen ve mesaj',
  'notifications.preview.sender': 'Yalnız gönderen',
  'notifications.preview.hidden': 'Hiçbir ayrıntı',
  'notifications.previewHint': 'Mesaj metni bildirim servisine şifreli iletilir ama kilit ekranında görünebilir.',
  'mute.label': 'Sessize al',
  'mute.1h': '1 saat',
  'mute.8h': '8 saat',
  'mute.1w': '1 hafta',
  'mute.forever': 'Her zaman',
  'mute.off': 'Sessizi kaldır',
  'mute.active': 'Sessizde',
  'report.message': 'Bildir',
  'report.user': 'Kullanıcıyı bildir',
  'report.title': 'Bildir',
  'report.reason': 'Neden bildiriyorsun?',
  'report.reason.spam': 'Spam veya istenmeyen mesaj',
  'report.reason.harassment': 'Taciz veya zorbalık',
  'report.reason.hate': 'Nefret söylemi',
  'report.reason.sexual_content': 'Cinsel içerik',
  'report.reason.child_safety': 'Bir çocuğun güvenliği risk altında',
  'report.reason.self_harm': 'Kendine zarar verme',
  'report.reason.violence': 'Şiddet veya tehdit',
  'report.reason.impersonation': 'Başkasının kimliğine bürünme',
  'report.reason.scam': 'Dolandırıcılık',
  'report.reason.other': 'Diğer',
  'report.details': 'Eklemek istediğin bilgi (isteğe bağlı)',
  'report.includeRecent': { one: 'Son {count} mesajı kanıt olarak ekle', other: 'Son {count} mesajı kanıt olarak ekle' },
  'report.evidenceNote': 'Yalnızca bildirdiğin mesaj ve eklemeyi seçtiğin mesajlar inceleme ekibiyle paylaşılır.',
  'report.alsoBlock': 'Bu kişiyi engelle',
  'report.submit': 'Bildirimi gönder',
  'report.sent': 'Teşekkürler. Bildirimin alındı ve incelenecek.',
  'report.emergency': 'Biri şu an tehlikedeyse hemen 112 Acil Çağrı Merkezi’ni ara.',
  'common.close': 'Kapat',
  'conn.connected': 'Bağlı',
  'conn.reconnecting': 'Yeniden bağlanıyor…',
  'onboarding.title': 'DijitalApp’i nasıl kullanacaksın?',
  'onboarding.subtitle': 'Ana ekranını buna göre hazırlarız. İstediğin zaman değiştirebilirsin.',
  'onboarding.continue': 'Devam et',
  'onboarding.skip': 'Şimdilik atla',
  'onboarding.personaNote': 'Mod seçimi yalnızca görünümü değiştirir; yetki veya rol vermez.',
  'shell.activeSpace': 'Etkin alan',
  'shell.minorNotice': 'Hesabın yaşına uygun korumalı ayarlarla çalışıyor.',
  'shell.guardianPending': 'Bazı özellikler veli/vasi onayı tamamlanana kadar kapalı.',
  'module.disabled.title': 'Bu bölüm henüz açık değil',
  'module.disabled.body': '{module} geliştirme aşamasında ve şu an kapalı. Hazır olduğunda burada göreceksin.',
  'spaces.title': 'Alanlarım',
  'spaces.create': 'Yeni alan',
  'spaces.name': 'Alan adı',
  'spaces.type': 'Alan türü',
  'spaces.members': { one: '{count} üye', other: '{count} üye' },
  'spaces.type.personal': 'Kişisel',
  'spaces.type.family': 'Aile',
  'spaces.type.community': 'Topluluk',
  'spaces.type.school': 'Eğitim',
  'spaces.type.business': 'İş',
  'spaces.type.event': 'Etkinlik',
  'spaces.verificationRequired': 'Eğitim ve iş alanları kurum doğrulaması gerektirir.',
  'spaces.persona': 'Bu alandaki mod',
  'settings.title': 'Ayarlar',
  'settings.devices': 'Cihazlar',
  'settings.privacy': 'Gizlilik',
  'settings.appearance': 'Görünüm',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.theme.system': 'Sistem',
  'settings.language': 'Dil',
  'devices.current': 'Bu cihaz',
  'devices.lastActive': 'Son etkinlik: {date}',
  'devices.firstSeen': 'İlk giriş: {date}',
  'devices.signOut': 'Oturumu kapat',
  'devices.signOutOthers': 'Diğer tüm cihazlardan çıkış yap',
  'devices.count': { one: '{count} etkin cihaz', other: '{count} etkin cihaz' },
  'privacy.lockedByAge': 'Yaş politikası nedeniyle kilitli',
  'privacy.saved': 'Gizlilik ayarları kaydedildi',
  'privacy.profileDiscoverable': 'Profilim aramalarda bulunabilsin',
  'privacy.dmFromNonContacts': 'Kişilerim dışındakiler mesaj gönderebilsin',
  'privacy.lastSeen': 'Son görülme',
  'privacy.readReceipts': 'Okundu bilgisi',
  'privacy.phoneVisible': 'Telefon numaram görünsün',
  'privacy.audience.everyone': 'Herkes',
  'privacy.audience.contacts': 'Kişilerim',
  'privacy.audience.nobody': 'Hiç kimse',
  'common.save': 'Kaydet',
  'common.cancel': 'Vazgeç',
  'common.retry': 'Tekrar dene',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
  'conn.offline': 'Çevrimdışı',
  'conn.connecting': 'Bağlanıyor…',
  'error.AUTH_INVALID_CREDENTIALS': 'E-posta/kullanıcı adı veya parola hatalı.',
  'error.AUTH_SESSION_EXPIRED': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
  'error.AUTH_REQUIRED': 'Devam etmek için giriş yapmalısın.',
  'error.AUTH_ORIGIN_REJECTED': 'İstek güvenlik kontrolünden geçmedi. Sayfayı yenileyip tekrar dene.',
  'error.AGE_BELOW_MINIMUM': 'Üzgünüz, bulunduğun ülkede bu yaşta DijitalApp hesabı açılamıyor.',
  'error.EMAIL_TAKEN': 'Bu e-posta adresiyle zaten bir hesap var.',
  'error.USERNAME_TAKEN': 'Bu kullanıcı adı kullanılamıyor.',
  'error.USERNAME_RESERVED': 'Bu kullanıcı adı ayrılmış, başka bir ad seç.',
  'error.VALIDATION_FAILED': 'Girdiğin bilgileri kontrol et.',
  'error.RATE_LIMITED': 'Çok fazla deneme yaptın. Biraz bekleyip tekrar dene.',
  'error.FORBIDDEN': 'Bu işlem için yetkin yok.',
  'error.NOT_FOUND': 'Aradığın şey bulunamadı.',
  'error.POLICY_LOCKED': 'Bu ayar yaşına uygun güvenlik politikası nedeniyle değiştirilemez.',
  'error.SPACE_VERIFICATION_REQUIRED': 'Bu alan türü kurum doğrulaması gerektirir.',
  'error.TERMS_NOT_ACCEPTED': 'Devam etmek için koşulları kabul etmelisin.',
  'error.ENTITLEMENT_LIMIT': 'Planındaki sınıra ulaştın.',
  'error.EMAIL_TOKEN_INVALID': 'Bu bağlantı geçersiz, kullanılmış ya da süresi dolmuş. Yeni bir bağlantı iste.',
  'error.PASSKEY_FAILED': 'Passkey doğrulanamadı. Tekrar dene.',
  'error.EMAIL_NOT_VERIFIED': 'Bu işlem için önce e-posta adresini doğrula.',
  'error.MESSAGING_NOT_ALLOWED': 'Bu kişiye şu an mesaj gönderemezsin.',
  'error.MESSAGE_TOO_LARGE': 'Mesaj çok uzun.',
  'error.AUTH_TICKET_INVALID': 'Canlı bağlantı kurulamadı. Tekrar deneniyor.',
  'error.PROTOCOL_INVALID_FRAME': 'Sunucuyla iletişimde bir sorun oldu.',
  'error.REGISTRATION_CLOSED': 'Yeni kayıtlar şu an kapalı.',
  'error.INVITE_INVALID': 'Davet kodu geçersiz, kullanılmış ya da süresi dolmuş.',
  'auth.inviteCode': 'Davet kodu',
  'auth.inviteHint': 'DijitalApp şu an davetle açılan kapalı beta aşamasında.',
  'auth.registrationClosed': 'Yeni kayıtlar şu an kapalı. Hesabın varsa giriş yapabilirsin.',
  'error.NETWORK': 'Sunucuya ulaşılamıyor. Bağlantını kontrol et.',
  'error.UNKNOWN': 'Beklenmeyen bir sorun oluştu. Tekrar dene.',
} satisfies Record<string, Entry>;

export type MessageKey = keyof typeof tr;

export const en: Record<MessageKey, Entry> = {
  'app.loading': 'Loading…',
  'nav.messages': 'Messages',
  'nav.calls': 'Calls',
  'nav.spaces': 'Spaces',
  'nav.discover': 'Discover',
  'nav.ai': 'AI',
  'nav.settings': 'Settings',
  'auth.login.title': 'Sign in',
  'auth.register.title': 'Create account',
  'auth.identifier': 'Email or username',
  'auth.email': 'Email',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.passwordHint': 'At least 10 characters',
  'auth.displayName': 'Display name',
  'auth.birthDate': 'Date of birth',
  'auth.birthDateHint': 'Used to apply age-appropriate safety settings; never shown on your profile.',
  'auth.country': 'Country',
  'auth.acceptTerms': 'I have read and accept the terms of use and the privacy notice.',
  'auth.submitLogin': 'Sign in',
  'auth.submitRegister': 'Create account',
  'auth.noAccount': 'No account yet?',
  'auth.haveAccount': 'Already have an account?',
  'auth.logout': 'Sign out',
  'auth.or': 'or',
  'auth.forgotLink': 'Forgot password',
  'auth.forgot.title': 'Reset your password',
  'auth.forgot.body': 'Enter your account email. If an account exists we will send a reset link.',
  'auth.forgot.submit': 'Send link',
  'auth.forgot.sent': 'If an account is registered to this address, a reset link has been sent. It is valid for 30 minutes.',
  'auth.reset.title': 'Choose a new password',
  'auth.reset.newPassword': 'New password',
  'auth.reset.submit': 'Change password',
  'auth.reset.done': 'Your password was changed and all sessions were signed out. Sign in with your new password.',
  'auth.verify.title': 'Email verification',
  'auth.verify.working': 'Verifying…',
  'auth.verify.success': 'Your email address is verified.',
  'auth.verify.continue': 'Back to the app',
  'auth.passkey.login': 'Sign in with a passkey',
  'auth.passkey.unsupported': 'This browser does not support passkeys.',
  'auth.passkey.cancelled': 'The passkey request was cancelled.',
  'banner.emailUnverified': 'Verify your email address: {email}',
  'banner.resend': 'Resend link',
  'banner.resent': 'Verification link sent.',
  'passkeys.title': 'Passkeys',
  'passkeys.body': 'Sign in with your device lock (fingerprint, face, PIN) instead of a password.',
  'passkeys.add': 'Add a passkey',
  'passkeys.empty': 'You have not added a passkey yet.',
  'passkeys.created': 'Added: {date}',
  'passkeys.lastUsed': 'Last used: {date}',
  'passkeys.remove': 'Remove',
  'passkeys.added': 'Passkey added.',
  'passkeys.synced': 'Synced',
  'mail.verify.subject': '{brand}: verify your email address',
  'mail.verify.body': 'Hi {name},\n\nUse the link below to verify the email address of your {brand} account. The link is valid for 24 hours.',
  'mail.verify.cta': 'Verify my email',
  'mail.reset.subject': '{brand}: password reset',
  'mail.reset.body': 'Hi {name},\n\nUse the link below to reset your password. It is valid for 30 minutes and can be used once. If you did not request this, ignore this email; your password will not change.',
  'mail.reset.cta': 'Reset my password',
  'mail.passwordChanged.subject': '{brand}: your password was changed',
  'mail.passwordChanged.body': 'Hi {name},\n\nThe password of your {brand} account was just changed and all sessions were signed out. If this was not you, contact support immediately.',
  'mail.passwordChanged.cta': 'Sign in',
  'mail.footer': 'This email was sent automatically because of an action on your {brand} account.',
  'chat.title': 'Chats',
  'chat.search': 'Search chats',
  'chat.new': 'New chat',
  'chat.empty': 'No chats yet. Add someone by @username under Contacts and start a chat.',
  'chat.select': 'Select a chat',
  'chat.selectBody': 'Pick a chat from the list or start a new one.',
  'chat.placeholder': 'Write a message',
  'chat.send': 'Send',
  'chat.typing': '{name} is typing…',
  'chat.loadOlder': 'Load earlier messages',
  'chat.today': 'Today',
  'chat.yesterday': 'Yesterday',
  'chat.you': 'You',
  'chat.noMessages': 'No messages yet. Say hello.',
  'chat.status.queued': 'Waiting to send',
  'chat.status.sending': 'Sending',
  'chat.status.sent': 'Sent',
  'chat.status.delivered': 'Delivered',
  'chat.status.read': 'Read',
  'chat.status.failed': 'Not sent',
  'chat.retry': 'Retry',
  'chat.discard': 'Delete',
  'chat.cannotSend': 'You cannot message this person right now.',
  'chat.waitForReply': 'You can reply once this person adds you to their contacts or writes to you.',
  'chat.verifyToSend': 'Verify your email address to send messages.',
  'chat.restrictedToSend': 'Messaging opens once a parent/guardian has approved.',
  'chat.encryptionNotice': 'Messages travel to the server over an encrypted connection (TLS) and are stored there. End-to-end encryption is not available yet.',
  'chat.unread': { one: '{count} unread message', other: '{count} unread messages' },
  'chat.back': 'Back to chats',
  'contacts.title': 'Contacts',
  'contacts.add': 'Add',
  'contacts.addLabel': 'Add a contact by username',
  'contacts.usernamePlaceholder': '@username',
  'contacts.added': '{name} added to your contacts.',
  'contacts.empty': 'No contacts yet.',
  'contacts.message': 'Message',
  'contacts.block': 'Block',
  'contacts.unblock': 'Unblock',
  'contacts.blocked': 'Blocked',
  'contacts.hint': 'Adding someone lets them message you. To message them, they need to add you too or accept messages from everyone.',
  'push.newMessage': 'New message',
  'push.newMessageHidden': 'You have a new message',
  'notifications.title': 'Notifications',
  'notifications.body': 'Hear about new messages while the app is closed.',
  'notifications.enable': 'Turn on notifications on this device',
  'notifications.disable': 'Turn off on this device',
  'notifications.enabled': 'Notifications are on for this device.',
  'notifications.denied': 'The browser blocked notifications. You can allow them in the site settings.',
  'notifications.unsupported': 'This browser does not support web notifications.',
  'notifications.unavailable': 'Notifications are not available right now.',
  'notifications.preview': 'Show in notifications',
  'notifications.preview.full': 'Sender and message',
  'notifications.preview.sender': 'Sender only',
  'notifications.preview.hidden': 'No details',
  'notifications.previewHint': 'Message text is sent encrypted to the push service but may appear on your lock screen.',
  'mute.label': 'Mute',
  'mute.1h': '1 hour',
  'mute.8h': '8 hours',
  'mute.1w': '1 week',
  'mute.forever': 'Always',
  'mute.off': 'Unmute',
  'mute.active': 'Muted',
  'report.message': 'Report',
  'report.user': 'Report user',
  'report.title': 'Report',
  'report.reason': 'Why are you reporting this?',
  'report.reason.spam': 'Spam or unwanted messages',
  'report.reason.harassment': 'Harassment or bullying',
  'report.reason.hate': 'Hate speech',
  'report.reason.sexual_content': 'Sexual content',
  'report.reason.child_safety': 'A child’s safety is at risk',
  'report.reason.self_harm': 'Self-harm',
  'report.reason.violence': 'Violence or threats',
  'report.reason.impersonation': 'Impersonation',
  'report.reason.scam': 'Scam or fraud',
  'report.reason.other': 'Something else',
  'report.details': 'Anything else we should know (optional)',
  'report.includeRecent': { one: 'Include the last {count} message as evidence', other: 'Include the last {count} messages as evidence' },
  'report.evidenceNote': 'Only the reported message and the messages you choose to include are shared with the review team.',
  'report.alsoBlock': 'Block this person',
  'report.submit': 'Send report',
  'report.sent': 'Thank you. Your report was received and will be reviewed.',
  'report.emergency': 'If someone is in immediate danger, call your local emergency number now.',
  'common.close': 'Close',
  'conn.connected': 'Connected',
  'conn.reconnecting': 'Reconnecting…',
  'onboarding.title': 'How will you use DijitalApp?',
  'onboarding.subtitle': 'We tailor your home screen to it. You can change this any time.',
  'onboarding.continue': 'Continue',
  'onboarding.skip': 'Skip for now',
  'onboarding.personaNote': 'A mode only changes what you see; it never grants permissions or roles.',
  'shell.activeSpace': 'Active space',
  'shell.minorNotice': 'Your account uses protected settings appropriate for your age.',
  'shell.guardianPending': 'Some features stay off until a parent/guardian approves.',
  'module.disabled.title': 'This section is not open yet',
  'module.disabled.body': '{module} is under development and currently disabled. It will appear here when ready.',
  'spaces.title': 'My spaces',
  'spaces.create': 'New space',
  'spaces.name': 'Space name',
  'spaces.type': 'Space type',
  'spaces.members': { one: '{count} member', other: '{count} members' },
  'spaces.type.personal': 'Personal',
  'spaces.type.family': 'Family',
  'spaces.type.community': 'Community',
  'spaces.type.school': 'Education',
  'spaces.type.business': 'Business',
  'spaces.type.event': 'Event',
  'spaces.verificationRequired': 'Education and business spaces require organization verification.',
  'spaces.persona': 'Mode in this space',
  'settings.title': 'Settings',
  'settings.devices': 'Devices',
  'settings.privacy': 'Privacy',
  'settings.appearance': 'Appearance',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.theme.system': 'System',
  'settings.language': 'Language',
  'devices.current': 'This device',
  'devices.lastActive': 'Last active: {date}',
  'devices.firstSeen': 'First sign-in: {date}',
  'devices.signOut': 'Sign out',
  'devices.signOutOthers': 'Sign out of all other devices',
  'devices.count': { one: '{count} active device', other: '{count} active devices' },
  'privacy.lockedByAge': 'Locked by age policy',
  'privacy.saved': 'Privacy settings saved',
  'privacy.profileDiscoverable': 'Let people find my profile in search',
  'privacy.dmFromNonContacts': 'Allow messages from people not in my contacts',
  'privacy.lastSeen': 'Last seen',
  'privacy.readReceipts': 'Read receipts',
  'privacy.phoneVisible': 'Show my phone number',
  'privacy.audience.everyone': 'Everyone',
  'privacy.audience.contacts': 'My contacts',
  'privacy.audience.nobody': 'Nobody',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.retry': 'Retry',
  'common.on': 'On',
  'common.off': 'Off',
  'conn.offline': 'Offline',
  'conn.connecting': 'Connecting…',
  'error.AUTH_INVALID_CREDENTIALS': 'Incorrect email/username or password.',
  'error.AUTH_SESSION_EXPIRED': 'Your session has expired. Please sign in again.',
  'error.AUTH_REQUIRED': 'Please sign in to continue.',
  'error.AUTH_ORIGIN_REJECTED': 'The request failed a security check. Reload the page and try again.',
  'error.AGE_BELOW_MINIMUM': 'Sorry, a DijitalApp account cannot be created at this age in your country.',
  'error.EMAIL_TAKEN': 'An account with this email already exists.',
  'error.USERNAME_TAKEN': 'This username is not available.',
  'error.USERNAME_RESERVED': 'This username is reserved; please choose another.',
  'error.VALIDATION_FAILED': 'Please check the information you entered.',
  'error.RATE_LIMITED': 'Too many attempts. Please wait a moment and try again.',
  'error.FORBIDDEN': 'You are not allowed to do this.',
  'error.NOT_FOUND': 'We could not find what you were looking for.',
  'error.POLICY_LOCKED': 'This setting cannot be changed because of your age-appropriate safety policy.',
  'error.SPACE_VERIFICATION_REQUIRED': 'This space type requires organization verification.',
  'error.TERMS_NOT_ACCEPTED': 'You need to accept the terms to continue.',
  'error.ENTITLEMENT_LIMIT': 'You have reached your plan limit.',
  'error.EMAIL_TOKEN_INVALID': 'This link is invalid, already used or expired. Request a new one.',
  'error.PASSKEY_FAILED': 'The passkey could not be verified. Please try again.',
  'error.EMAIL_NOT_VERIFIED': 'Verify your email address first.',
  'error.MESSAGING_NOT_ALLOWED': 'You cannot message this person right now.',
  'error.MESSAGE_TOO_LARGE': 'The message is too long.',
  'error.AUTH_TICKET_INVALID': 'Could not open the live connection. Retrying.',
  'error.PROTOCOL_INVALID_FRAME': 'Something went wrong talking to the server.',
  'error.REGISTRATION_CLOSED': 'New sign-ups are closed right now.',
  'error.INVITE_INVALID': 'This invite code is invalid, already used or expired.',
  'auth.inviteCode': 'Invite code',
  'auth.inviteHint': 'DijitalApp is in an invite-only closed beta.',
  'auth.registrationClosed': 'New sign-ups are closed right now. If you have an account, sign in.',
  'error.NETWORK': 'Cannot reach the server. Check your connection.',
  'error.UNKNOWN': 'Something unexpected happened. Please try again.',
};
